import { render, staticRenderFns } from "./ToolbarIconButton.vue?vue&type=template&id=1a2eeb51"
import script from "./ToolbarIconButton.vue?vue&type=script&lang=js"
export * from "./ToolbarIconButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports